import {
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CLink,
} from '@coreui/react-pro'
import React from 'react'

const OCard = (props: {
  className?: string
  CHeaderClassName?: string
  title?: string
  CBodyClassName?: string
  CFooterClassName?: string
  CLinkClassName?: string
  CCardTitleClassName?: string
  children?: React.ReactNode
  headerChildren?: React.ReactNode
  footerPath?: string
  cardStyle?: React.CSSProperties
}): JSX.Element => {
  return (
    <>
      <CCard className={props.className} style={props.cardStyle}>
        <CCardHeader className={props.CHeaderClassName}>
          <div className="row">
            <div className="col">
              <h4 className={`h4 ${props.CCardTitleClassName}`}>
                {props.title}
              </h4>
            </div>
            <div className="col">{props?.headerChildren}</div>
          </div>
        </CCardHeader>
        <CCardBody className={props.CBodyClassName}>{props.children}</CCardBody>
        <CCardFooter className={props.CFooterClassName}>
          <CLink
            className={`font-weight-bold font-xs float-end ${
              props.CLinkClassName ? props.CLinkClassName : ''
            }`}
            href={props.footerPath}
            rel="noopener norefferer"
            target="_self"
          >
            More
            {''} <i className="fa fa-angle-double-right fa-lg"></i>
          </CLink>
        </CCardFooter>
      </CCard>
    </>
  )
}

export default OCard
